import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import TermOfServiceBody from '../components/privacy/TermOfServiceBody';

export const TermOfServiceScreen = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>TERMS OF SERVICE</title>
                <meta name='description' content='Terms of service' />
            </Helmet>
            <TermOfServiceBody />
        </>
    );
};

export default TermOfServiceScreen;
